export const getOptions = <T extends { id: string }>(array: T[]): string[] => {
  const emptyArray: string[] = [];

  return array.reduce(
    (accumulator, currentValue) => [...accumulator, currentValue.id],
    emptyArray,
  );
};
